import React from "react";
import SectionLabel from "./SectionLabel";

const ProjectList = ({ title, items }) => {
  return (
    <section className="scroll-mt-24">
      <SectionLabel>{title}</SectionLabel>
      <ul className="m-0 flex list-none flex-col gap-[18px] p-0">
        {items.map((item) => (
          <li key={item.id}>
            <div className="flex flex-wrap items-center gap-x-2.5 gap-y-1">
              {item.badge ? (
                <span className="inline-flex items-center rounded-full bg-yellow-500/10 px-2 py-0.5 text-[9px] font-bold uppercase tracking-wide text-yellow-800 dark:bg-yellow-700/10 dark:text-yellow-500">
                  {item.badge}
                </span>
              ) : null}
              {item.href ? (
                <a
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[15px] font-medium text-zinc-950 hover:underline dark:text-zinc-50"
                >
                  {item.title}
                </a>
              ) : (
                <span className="text-[15px] font-medium text-zinc-950 dark:text-zinc-50">
                  {item.title}
                </span>
              )}
              {item.href && item.linkLabel ? (
                <a
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-zinc-400 underline decoration-1 underline-offset-2 dark:text-neutral-400"
                >
                  {item.linkLabel}
                </a>
              ) : null}
            </div>
            {item.description ? (
              <p className="mt-1 max-w-3xl text-sm leading-6 text-zinc-700 dark:text-zinc-300">
                {item.description}
              </p>
            ) : null}
            {item.stack ? (
              <p className="mt-1 text-xs text-zinc-500">{item.stack}</p>
            ) : null}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ProjectList;
